export enum FeatureFlag {
  MARKETPLACE_LAWMATICS = 'marketplace_lawmatics_integration_enabled',
  MARKETPLACE_COASTAL = 'marketplace_coastal_integration_enabled',
  MARKETPLACE_LITIFY = 'marketplace_litify_integration_enabled',
  NOTIFICATION_BANNER = 'marketplace_notification_banner_enabled',
  MY_CASE_INTEGRATION = 'marketplace_mycase_integration_enabled',
  MARKETPLACE_DIRECT_SHARE_API = 'marketplace_direct_share_api_enabled',
  MARKETPLACE_DIRECT_SHARE_API_V2 = 'marketplace_direct_share_api_v2_enabled',
  MARKETPLACE_WEBHOOKS = 'marketplace_webhooks_enabled',
  MARKETPLACE_WEBHOOKS_V2 = 'marketplace_webhooks_v2_enabled',
  MARKETPLACE_MULTI_WEBHOOKS_ENABLED = 'marketplace_multi_webhooks_enabled',
  MARKETPLACE_REFERRAL_SETTINGS = 'marketplace_referral_settings_enabled',
  MARKETPLACE_MATCH_FEE_FOR_ALL_REFERRALS = 'marketplace_match_fee_for_all_referrals_enabled',
  FIRM_PAYMENTS_PROMO_CODE_ENABLED = 'firm_payments_promo_code_enabled',
  MY_REFERRAL_NETWORK_ENABLED = 'my_referral_network_enabled',
  MPN_JURISDICTION_ROUTING = 'mpn_per_member_jurisdiction_routing_enabled', // https://linear.app/attorney-share/issue/ENG-1575
  MARKETPLACE_BROADCAST = 'marketplace_broadcast_enabled',
  LEAD_SCORE_MARKETPLACE_ENABLED = 'lead_score_marketplace_enabled',
  REMOVE_FOCUSED_AND_DETAILED_LEVELS = 'marketplace_remove_focused_and_detailed_levels', // https://linear.app/attorney-share/issue/ENG-353
  MY_TASKS_ENABLED = 'marketplace_my_tasks_enabled',
  SAVED_FILTERS_ENABLED = 'saved_filters_enabled',
  AUTOPROPOSAL = 'autoproposal',
  FILTERS_NOTIFICATIONS = 'filters_notifications',
  MARKETPLACE_IN_PROGRESS = 'marketplace_in_progress_enabled',
  MARKETPLACE_CHAT_V2 = 'marketplace_chat_v2_enabled',
  UPDATE_SIGNED_CASES = 'marketplace_update_signed_cases_enabled',
  MY_CASES_V4_5 = 'marketplace_my_cases_v4_5_enabled',
  MARKETPLACE_REMOVE_ORG_MEMBERS = 'marketplace_remove_org_members_enabled',
  CASE_RECOMMENDATIONS = 'marketplace_case_recommendations_enabled',
  MARKETPLACE_FOR_YOU = 'marketplace_for_you_enabled',
  ADBUTLER_CASE_DETAILS_BANNER = 'marketplace_adbutler_case_details_banner_enabled',
  ADBUTLER_MARKETPLACE_BANNER = 'marketplace_adbutler_banner_enabled',
  MARKETPLACE_UNIFIED_LOCATION_FILTER = 'marketplace_unified_location_filter_enabled', // https://linear.app/attorney-share/issue/ENG-1580
  // Case Profile Page Redesign — gates the whole redesign, not just the status
  // line: https://linear.app/attorney-share/issue/ENG-1872
  CASE_PROFILE_REDESIGN_ENABLED = 'marketplace_case_profile_redesign_enabled',
  // Midstream Referrals "Withhold Client Contact" — gates the opt-in and the new
  // affordances only. Masking withheld contact info is data-driven and never
  // depends on this flag: https://linear.app/attorney-share/issue/ENG-1983
  WITHHOLD_CLIENT_CONTACT_ENABLED = 'marketplace_withhold_client_contact_enabled',
  // Ask AttorneyShare: the header button, the side drawer and the /assistant
  // page. Flag off renders the app exactly as before.
  ASSISTANT_ENABLED = 'marketplace_assistant_enabled',
  // Unmatch & Repost: the Case Profile pill, the reason modal and the My
  // Referrals kebab. Who may act is data-driven (`actions.unmatch_and_repost`);
  // the flag only keeps the UI out of sight until the backend is live:
  // https://linear.app/attorney-share/issue/ENG-1708
  UNMATCH_AND_REPOST_ENABLED = 'marketplace_unmatch_and_repost_enabled',
}
